import React from 'react';
import GenericTableFilter from '../../../../../components/common/GenericTableFilter';

const ApprovalLimitsFilter = ({ 
    filterFields, 
    columns, 
    customFilterTypes, 
    customFilterOptions, 
    handleSearch, 
    handleApplyFilters, 
    handleResetFilters 
}) => {
    return (
        <div className="mb-2">
            <GenericTableFilter
                filterFields={filterFields}
                columns={columns}
                initialFilters={{ isActive: true }}
                onSearch={handleSearch}
                onApplyFilters={handleApplyFilters}
                onResetFilters={handleResetFilters}
                customFilterTypes={customFilterTypes}
                customFilterOptions={customFilterOptions}
            />
        </div>
    );
};

export default ApprovalLimitsFilter; 